import React, { useRef } from 'react';
import { Modal } from '@milanote/roma';
import { cx } from '@milanote/roma/utils';

type Props = {
    children?: React.ReactNode;
    className?: string;
    closeModal?: () => void;
    isOpen?: boolean;
};

type TitleProps = React.HTMLAttributes<HTMLHeadingElement>;

/**
 * Renders a standard title for admin dashboard modals.
 */
export const Title: React.FC<TitleProps> = ({ children, className, ...props }) => (
    <h2 className={cx('text-display-sm text-primary', className)} {...props}>
        {children}
    </h2>
);

const AdminDashboardModalContent: React.FC<Pick<Props, 'children' | 'className'>> = ({ children, className }) => {
    return (
        <Modal className="max-w-180">
            <Modal.Dialog className="my-8">
                <Modal.DialogContent
                    width="full"
                    className={cx('max-w-180 flex flex-col gap-lg text-primary', className)}
                >
                    {children}
                </Modal.DialogContent>
            </Modal.Dialog>
        </Modal>
    );
};

const AdminDashboardModal: React.FC<Props> = ({ children, closeModal, className, isOpen = true }) => {
    const previousChildren = useRef<React.ReactNode>(children);

    if (isOpen && children) {
        previousChildren.current = children;
    }

    const onOpenChange = (open: boolean) => {
        if (!open) closeModal?.();
    };

    return (
        <Modal.Overlay isDismissable backgroundStyle="dim" isOpen={isOpen} onOpenChange={onOpenChange}>
            <AdminDashboardModalContent className={className}>
                {children || previousChildren.current}
            </AdminDashboardModalContent>
        </Modal.Overlay>
    );
};

export default AdminDashboardModal;
